__turbopack_context__.v({
  "deskriptor": "hero-block-module-scss-module__7cG0fq__deskriptor",
  "heroblock": "hero-block-module-scss-module__7cG0fq__heroblock",
  "herocontainer": "hero-block-module-scss-module__7cG0fq__herocontainer",
  "text": "hero-block-module-scss-module__7cG0fq__text",
  "title": "hero-block-module-scss-module__7cG0fq__title",
});
